import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-best-interactive-flat-panel-company-in-india',
  templateUrl: './best-interactive-flat-panel-company-in-india.component.html',
  styleUrls: ['./best-interactive-flat-panel-company-in-india.component.scss']
})
export class BestInteractiveFlatPanelCompanyInIndiaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best Interactive Flat Panel Company in India | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Looking for the best Interactive Flat Panel, Smart Board or Digital Board company in India? Explore VIRSA Interactive Flat Panels for schools, colleges, universities and institutions.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'best Interactive Flat Panel company in India, Interactive Flat Panel company India, best IFP company India, best IFP provider India, Interactive Flat Panel manufacturer India, Interactive Flat Panel supplier India, smart board company India, digital board company India, smart classroom company India, Interactive Flat Panel for schools, VIRSA Interactive Flat Panel, VIRSA Smart Board, VIRSA Digital Board, Interactive Flat Panel company Delhi, IFP company Noida, Smart Board company Gurugram, Interactive Flat Panel Mumbai, IFP company Bengaluru, Digital Board Hyderabad, Smart Board Pune, Interactive Flat Panel Chennai, IFP Kolkata, Digital Board Ahmedabad, Smart Board Jaipur, IFP Lucknow'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
